import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import NavbarComponent from "../Navbar";
import Footer from "../Footer";
import { ThemeProvider } from "styled-components";
import { useSelector } from "react-redux";

const Layout = () => {

  const theme = useSelector((state: any) => state.persistedThemeReducer);

  return (
    <ThemeProvider theme={theme}>
      <NavbarComponent />
      <Outlet />
      <Footer />
    </ThemeProvider>
  );
};

export default Layout;
